
$(document).on('click','.dropdown__header', function() {
    $(this).parent().find('.dropdown__icon').toggleClass('animated');
    $(this).parent().find('.dropdown__items').toggleClass('visible')

});
